export enum VariationType {
    DEFAULT = 'DEFAULT',
    COLOR = 'COLOR',
    IMAGE = 'IMAGE',
}
